import { API_PDC_URL_V1, API_PDC_URL_V2 } from "../../config";
import { createHttpHeaderWithAuthorization } from "../services/http-header";
import { callWithRetry } from "../services/callWithRetry";
import { CodificaError } from "../../libs/manage-message";

export const permissionsConstants = {
  GET_SETTINGS_COMPANY_START: "GET_SETTINGS_COMPANY_START",
  GET_SETTINGS_COMPANY_SUCCESS: "GET_SETTINGS_COMPANY_SUCCESS",
  GET_SETTINGS_COMPANY_ERROR: "GET_SETTINGS_COMPANY_ERROR",

  GET_SETTINGS_USER_START: "GET_SETTINGS_USER_START",
  GET_SETTINGS_USER_SUCCESS: "GET_SETTINGS_USER_SUCCESS",
  GET_SETTINGS_USER_ERROR: "GET_SETTINGS_USER_ERROR",

  GET_SETTINGS_OTHER_USERS_START: "GET_SETTINGS_OTHER_USERS_START",
  GET_SETTINGS_OTHER_USERS_SUCCESS: "GET_SETTINGS_OTHER_USERS_SUCCESS",
  GET_SETTINGS_OTHER_USERS_ERROR: "GET_SETTINGS_OTHER_USERS_ERROR",

  GET_SETTINGS_COMPANIES_START: "GET_SETTINGS_COMPANIES_START",
  GET_SETTINGS_COMPANIES_SUCCESS: "GET_SETTINGS_COMPANIES_SUCCESS",
  GET_SETTINGS_COMPANIES_ERROR: "GET_SETTINGS_COMPANIES_ERROR",

  SAVE_PERMISSIONS_START: "SAVE_PERMISSIONS_START",
  SAVE_PERMISSIONS_SUCCESS: "SAVE_PERMISSIONS_SUCCESS",
  SAVE_PERMISSIONS_ERROR: "SAVE_PERMISSIONS_ERROR",

  LOAD_COMPANY_SETTINGS_START: "LOAD_COMPANY_SETTINGS_START",
  LOAD_COMPANY_SETTINGS_SUCCESS: "LOAD_COMPANY_SETTINGS_SUCCESS",
  LOAD_COMPANY_SETTINGS_ERROR: "LOAD_COMPANY_SETTINGS_ERROR",
  LOAD_SEARCHED_COMPANY_SETTINGS_SUCCESS: "LOAD_SEARCHED_COMPANY_SETTINGS_SUCCESS",
  CLEAR_SEARCHED_COMPANY_SETTINGS: "CLEAR_SEARCHED_COMPANY_SETTINGS"
};

/**
 * prendo il risultato dei permessi di un singolo cliente e lo plasmo a uso e consumo del FE
 */

function permissionsInGoodShape(currentPermissions, company) {
  let groupPermissionsArr = [];

  if (currentPermissions.length === undefined || currentPermissions.length === 0) {
    return null;
  }

  if (company === undefined) {
    return null;
  }

  /* filtro le liste di permessi che arrivano dal BE per groupId ed escludo per functionId i permessi che in quei gruppi non mi servono,
    salvandole nei gruppi che poi mi servono per il render nei vari componenti */

  let group1 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "1";
  });
  let group2 = currentPermissions[company].actions
    .filter((el) => {
      return el.group.id === "2";
    })
    .filter((el) => el.function.id !== "4");
  let group3 = currentPermissions[company].actions
    .filter((el) => {
      return el.group.id === "3";
    })
    .filter((el) => el.function.id !== "18")
    .filter((el) => el.function.id !== "74")
    .filter((el) => el.function.id !== "75")
    .filter((el) => el.function.id !== "76")
    .filter((el) => el.function.id !== "74")
    .filter((el) => el.function.id !== "84")
    .filter((el) => el.function.id !== "85");
  let group4 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "4";
  });
  let group5 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "5";
  });
  let group6 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "6";
  });
  let group7 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "7";
  });
  let group8 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "8";
  });
  let group9 = currentPermissions[company].actions
    .filter((el) => {
      return el.group.id === "9";
    })
    .filter((el) => el.function.id !== "89");
  let group10 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "10";
  });
  let group11 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "11";
  });
  let group12 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "12";
  });
  let group13 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "13";
  });
  let group14 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "14";
  });
  let group15 = currentPermissions[company].actions.filter((el) => {
    return el.group.id === "15";
  });

  /** salvo dentro i functionsArray l'oggetto dei permessi, con le chiavi che mi servono nei componenti */

  let functionsArray1 = [];
  let functionsArray2 = [];
  let functionsArray3 = [];
  let functionsArray4 = [];
  let functionsArray5 = [];
  let functionsArray6 = [];
  let functionsArray7 = [];
  let functionsArray8 = [];
  let functionsArray9 = [];
  let functionsArray10 = [];
  let functionsArray11 = [];
  let functionsArray12 = [];
  let functionsArray13 = [];
  let functionsArray14 = [];
  let functionsArray15 = [];

  for (let g1 = 0; g1 < group1.length; g1++) {
    functionsArray1.push({
      functionId: group1[g1].function.id,
      functionLabel: group1[g1].function.label,
      functionSmallLabel: group1[g1].function.smallLabel,
      functionName: group1[g1].name,
      isActive: group1[g1].isActive
    });
  }

  for (let g2 = 0; g2 < group2.length; g2++) {
    functionsArray2.push({
      functionId: group2[g2].function.id,
      functionLabel: group2[g2].function.label,
      functionSmallLabel: group2[g2].function.smallLabel,
      functionName: group2[g2].name,
      isActive: group2[g2].isActive
    });
  }

  for (let g3 = 0; g3 < group3.length; g3++) {
    functionsArray3.push({
      functionId: group3[g3].function.id,
      functionLabel: group3[g3].function.label,
      functionSmallLabel: group3[g3].function.smallLabel,
      functionName: group3[g3].name,
      isActive: group3[g3].isActive
    });
  }

  for (let g4 = 0; g4 < group4.length; g4++) {
    functionsArray4.push({
      functionId: group4[g4].function.id,
      functionLabel: group4[g4].function.label,
      functionSmallLabel: group4[g4].function.smallLabel,
      functionName: group4[g4].name,
      isActive: group4[g4].isActive
    });
  }

  for (let g5 = 0; g5 < group5.length; g5++) {
    functionsArray5.push({
      functionId: group5[g5].function.id,
      functionLabel: group5[g5].function.label,
      functionSmallLabel: group5[g5].function.smallLabel,
      functionName: group5[g5].name,
      isActive: group5[g5].isActive
    });
  }

  for (let g6 = 0; g6 < group6.length; g6++) {
    functionsArray6.push({
      functionId: group6[g6].function.id,
      functionLabel: group6[g6].function.label,
      functionSmallLabel: group6[g6].function.smallLabel,
      functionName: group6[g6].name,
      isActive: group6[g6].isActive
    });
  }

  for (let g7 = 0; g7 < group7.length; g7++) {
    functionsArray7.push({
      functionId: group7[g7].function.id,
      functionLabel: group7[g7].function.label,
      functionSmallLabel: group7[g7].function.smallLabel,
      functionName: group7[g7].name,
      isActive: group7[g7].isActive
    });
  }

  for (let g8 = 0; g8 < group8.length; g8++) {
    functionsArray8.push({
      functionId: group8[g8].function.id,
      functionLabel: group8[g8].function.label,
      functionSmallLabel: group8[g8].function.smallLabel,
      functionName: group8[g8].name,
      isActive: group8[g8].isActive
    });
  }

  for (let g9 = 0; g9 < group9.length; g9++) {
    functionsArray9.push({
      functionId: group9[g9].function.id,
      functionLabel: group9[g9].function.label,
      functionSmallLabel: group9[g9].function.smallLabel,
      functionName: group9[g9].name,
      isActive: group9[g9].isActive
    });
  }

  for (let g10 = 0; g10 < group10.length; g10++) {
    functionsArray10.push({
      functionId: group10[g10].function.id,
      functionLabel: group10[g10].function.label,
      functionSmallLabel: group10[g10].function.smallLabel,
      functionName: group10[g10].name,
      isActive: group10[g10].isActive
    });
  }

  for (let g11 = 0; g11 < group11.length; g11++) {
    functionsArray11.push({
      functionId: group11[g11].function.id,
      functionLabel: group11[g11].function.label,
      functionSmallLabel: group11[g11].function.smallLabel,
      functionName: group11[g11].name,
      isActive: group11[g11].isActive
    });
  }

  for (let g12 = 0; g12 < group12.length; g12++) {
    functionsArray12.push({
      functionId: group12[g12].function.id,
      functionLabel: group12[g12].function.label,
      functionSmallLabel: group12[g12].function.smallLabel,
      functionName: group12[g12].name,
      isActive: group12[g12].isActive
    });
  }

  for (let g13 = 0; g13 < group13.length; g13++) {
    functionsArray13.push({
      functionId: group13[g13].function.id,
      functionLabel: group13[g13].function.label,
      functionSmallLabel: group13[g13].function.smallLabel,
      functionName: group13[g13].name,
      isActive: group13[g13].isActive
    });
  }

  for (let g14 = 0; g14 < group14.length; g14++) {
    functionsArray14.push({
      functionId: group14[g14].function.id,
      functionLabel: group14[g14].function.label,
      functionSmallLabel: group14[g14].function.smallLabel,
      functionName: group14[g14].name,
      isActive: group14[g14].isActive
    });
  }

  for (let g15 = 0; g15 < group15.length; g15++) {
    functionsArray15.push({
      functionId: group15[g15].function.id,
      functionLabel: group15[g15].function.label,
      functionSmallLabel: group15[g15].function.smallLabel,
      functionName: group15[g15].name,
      isActive: group15[g15].isActive
    });
  }

  /** ricreo la struttura dati finale, comprensiva dei functionsArray popolati sopra, con le chiavi necessarie per il render nei componenti e la salvo in groupPermissionsArr*/
  if (
    group1.length > 0 ||
    group2.length > 0 ||
    group3.length > 0 ||
    group4.length > 0 ||
    group5.length > 0 ||
    group6.length > 0 ||
    group7.length > 0 ||
    group8.length > 0 ||
    group9.length > 0 ||
    group10.length > 0 ||
    group11.length > 0 ||
    group12.length > 0 ||
    group13.length > 0 ||
    group14.length > 0 ||
    group15.length > 0
  ) {
    for (let i = 1; i <= 15; i++) {
      let actualGroup =
        i === 1
          ? group1
          : i === 2
            ? group2
            : i === 3
              ? group3
              : i === 4
                ? group4
                : i === 5
                  ? group5
                  : i === 6
                    ? group6
                    : i === 7
                      ? group7
                      : i === 8
                        ? group8
                        : i === 9
                          ? group9
                          : i === 10
                            ? group10
                            : i === 11
                              ? group11
                              : i === 12
                                ? group12
                                : i === 13
                                  ? group13
                                  : i === 14
                                    ? group14
                                    : group15; // eval da problemi di vulnerabilità
      if (actualGroup.length > 0) {
        groupPermissionsArr.push({
          groupId: actualGroup[0].group.id,
          groupLabel: actualGroup[0].group.label,
          groupSmallLabel: actualGroup[0].group.smallLabel,
          groupName: actualGroup[0].group.name,
          permissions:
            i === 1
              ? functionsArray1
              : i === 2
                ? functionsArray2
                : i === 3
                  ? functionsArray3
                  : i === 4
                    ? functionsArray4
                    : i === 5
                      ? functionsArray5
                      : i === 6
                        ? functionsArray6
                        : i === 7
                          ? functionsArray7
                          : i === 8
                            ? functionsArray8
                            : i === 9
                              ? functionsArray9
                              : i === 10
                                ? functionsArray10
                                : i === 11
                                  ? functionsArray11
                                  : i === 12
                                    ? functionsArray12
                                    : i === 13
                                      ? functionsArray13
                                      : i === 14
                                        ? functionsArray14
                                        : functionsArray15
        });
      }
    }
  }

  return groupPermissionsArr;
}

export function getSettingsCompany(companySel) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = companySel ? companySel : getState().main.companyUuidSelected;
    const ownerId = getState().main.accountantUuidSelected;

    if (!itemId || !ownerId) return;

    new Promise(function(resolve, reject) {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/permissions/?ownerId=${ownerId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      dispatch({
        type: permissionsConstants.GET_SETTINGS_COMPANY_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200) {
            let originalPermissions = result.data._embedded.permissions;
            let currentPermissions = result.data._embedded.permissions;
            let groupPermissionsArr = await permissionsInGoodShape(currentPermissions, 0);

            dispatch({
              type: permissionsConstants.GET_SETTINGS_COMPANY_SUCCESS,
              payload: {
                itemId: itemId, // TODO verficare
                currentPermissions: groupPermissionsArr,
                originalPermissions: originalPermissions
              }
            });
          } else {
            dispatch({
              type: permissionsConstants.GET_SETTINGS_COMPANY_ERROR,
              error: result
            });
            CodificaError(result.status, result);
          }
          resolve(result);
        })
        .catch((err) => {
          CodificaError(err?.status || (err.message === "Network Error" ? "401" : null), err);
          dispatch({
            type: permissionsConstants.GET_SETTINGS_COMPANY_ERROR,
            error: err
          });
          reject(err);
        });
    });
  };
}

export function getSettingsCompanyForUser(
  itemId, userId, ownerId
) {
  if (!itemId || !ownerId) return undefined;
  return (dispatch, getState) => {
    const auth = getState().auth;
    new Promise(function(resolve, reject) {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/permissions/?ownerId=${ownerId}&itemId=${itemId}&userId=${userId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      dispatch({
        type: permissionsConstants.GET_SETTINGS_USER_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200) {
            let originalPermissions = result.data._embedded.permissions;
            let currentPermissions = result.data._embedded.permissions;
            let groupPermissionsArr = await permissionsInGoodShape(currentPermissions, 0);

            dispatch({
              type: permissionsConstants.GET_SETTINGS_USER_SUCCESS,
              payload: {
                itemId: itemId, // TODO verficare
                userId: userId,
                currentPermissions: groupPermissionsArr,
                originalPermissions: originalPermissions
              }
            });
          } else {
            CodificaError(result.status, result);
            dispatch({
              type: permissionsConstants.GET_SETTINGS_USER_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((err) => {
          dispatch({
            type: permissionsConstants.GET_SETTINGS_USER_ERROR,
            error: err
          });
          CodificaError(err?.status || (err.message === "Network Error" ? "401" : null), err);
          reject(err);
        });
    });
  };
}

export function getSettingsCompanyForOtherUsers(
  itemId, userId, ownerId
) {
  if (!itemId || !ownerId) return undefined;
  return (dispatch, getState) => {
    const auth = getState().auth;
    new Promise(function(resolve, reject) {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/permissions?ownerId=${ownerId}&itemId=${itemId}&userId=${userId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      dispatch({
        type: permissionsConstants.GET_SETTINGS_OTHER_USERS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200) {
            let originalPermissions = result.data._embedded.permissions;
            let currentPermissions = result.data._embedded.permissions;
            let groupPermissionsArr = await permissionsInGoodShape(currentPermissions, 0);

            dispatch({
              type: permissionsConstants.GET_SETTINGS_OTHER_USERS_SUCCESS,
              payload: {
                itemId: itemId, // TODO verficare
                userId: userId,
                currentPermissions: groupPermissionsArr,
                originalPermissions: originalPermissions
              }
            });
          } else {
            dispatch({
              type: permissionsConstants.GET_SETTINGS_OTHER_USERS_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: permissionsConstants.GET_SETTINGS_OTHER_USERS_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function getPermissionsClientsList(ownerId) {
  if (!ownerId) return undefined;
  return (dispatch, getState) => {
    const auth = getState().auth;

    new Promise(function(resolve, reject) {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/permissions?ownerId=${ownerId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };
      dispatch({
        type: permissionsConstants.GET_SETTINGS_COMPANIES_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200) {
            let res = result.data;

            let listClientsSettings = [];
            let payloadResult = res ? res._embedded.permissions : [];
            /* CICLO payload.res ogni record è un cliente */
            for (let cliente = 0; cliente < payloadResult.length; cliente++) {
              let funcCliente = payloadResult;
              let newArrayList = [];

              let groupPermissionsArr = await permissionsInGoodShape(funcCliente, cliente);

              if (groupPermissionsArr) {
                newArrayList.push({
                  companyId: funcCliente[cliente].itemId, // prendo il primo della lista perchè il companyId è duplicato
                  permissions: groupPermissionsArr
                });
              }
              listClientsSettings.push(newArrayList);
            }

            dispatch({
              type: permissionsConstants.GET_SETTINGS_COMPANIES_SUCCESS,
              payload: { listClientsSettings: listClientsSettings }
            });
          } else {
            dispatch({
              type: permissionsConstants.GET_SETTINGS_COMPANIES_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: permissionsConstants.GET_SETTINGS_COMPANIES_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

/**
 * salva i permessi delle aziende
 * @param {*} settings l'array delle funzionalità per ogni azienda da cambiare
 * @param {*} companyId il codice fiscale dell'azienda selezionata per richiamare la lista funzionalità dopo il salvataggio
 */
export function savePermissions(settings, itemId) {
  // Check gainsight track when attivitaScadenzeFatture change to true
  const actionFind = settings[0]?.permissions[0]?.actions?.find((x) => x.name === "attivitaScadenzeFatture");
  if (actionFind?.isActive === true) {
    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:ACTIVATE-PERMISSION-SCADENZEFATTURE");
    }
  }

  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PUT",
        url: `${API_PDC_URL_V1}/permissions`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: settings[0]
      };
      dispatch({
        type: permissionsConstants.SAVE_PERMISSIONS_START
      });
      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 202) {
            dispatch({
              type: permissionsConstants.SAVE_PERMISSIONS_SUCCESS,
              payload: {
                savedPermissions: settings.find((set) => {
                  return set.permissions[0].itemId === itemId;
                }),
                itemId: itemId
              }
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: permissionsConstants.SAVE_PERMISSIONS_ERROR,
            payload: { response }
          });
          reject(response);
        });
    });
  };
}

export function clearSearchedCompanyForSettings() {
  return (dispatch) => {
    dispatch({
      type: permissionsConstants.CLEAR_SEARCHED_COMPANY_SETTINGS
    });
  };
}

export function loadCompanyForSettings(
  searchTerm = "", page = 0, size = 40, companiesList, accountantID
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let isAppend = page > 0;

      // if (searchTerm === "" && !isAppend)
      dispatch({
        type: permissionsConstants.LOAD_COMPANY_SETTINGS_START,
        payload: { isAppend: isAppend }
      });

      const accountantGetParam = accountantID ? `&accountantId=${accountantID}` : "";
      let request = {
        method: "get",
        url: `${API_PDC_URL_V2}/anagrafica/companies?fullText=${searchTerm}&page=${page}&size=${size}${accountantGetParam}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            // se non ho risultati ma ho fatto ricerca allora non caricare nulla
            if (searchTerm !== "") {
              dispatch({
                type: permissionsConstants.LOAD_SEARCHED_COMPANY_SETTINGS_SUCCESS,
                payload: { data: result.data, companiesList: companiesList }
              });
              resolve([]);
            } else {
              dispatch({
                type: permissionsConstants.LOAD_COMPANY_SETTINGS_SUCCESS,
                payload: {
                  result: result.data.items.filter((el) => {
                    return el.classifier !== "STUDIO";
                  }),
                  hasMoreItems: result.data.hasMoreItems,
                  isAppend: isAppend
                }
              });
              resolve(result.data.items.filter((el) => {
                return el.classifier !== "STUDIO";
              }));
            }
          } else {
            dispatch({
              type: permissionsConstants.LOAD_COMPANY_SETTINGS_ERROR,
              payload: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: permissionsConstants.LOAD_COMPANY_SETTINGS_ERROR,
            payload: response
          });
          reject();
        });
    });
  };
}
